import React from "react";
import { ArrayField, Datagrid, DateField, FunctionField, NumberField, ReferenceField } from "react-admin";
import { employeeRequests } from "api/employeeApi";
import { accountRequests } from "api/accountApi";
import { settings } from "app";
import { staffRequestStatusLabel } from "components/Leaves/components/staffRequestStatusLabel";

const fullName = rec => [rec?.firstName, rec?.secondName, rec?.lastName].filter(Boolean).join(" ");

const ApproversTable = () => (
  <ArrayField
    source="staffRequest.approvers"
    label=""
    sort={{ field: "approvalOrder", order: "ASC" }}
  >
    <Datagrid
      bulkActionButtons={false}
      rowClick={false}
      sx={[settings.style.detailsDatagrid, { "& .column-approvalOrder": { width: "1%", whiteSpace: "nowrap" } }]}
    >
      <NumberField
        source="approvalOrder"
        label="Ред на одобрение"
        textAlign="center"
        sortable={false}
      />
      <FunctionField
        label="Одобряващ"
        sortable={false}
        render={rec =>
          // Role- or permission-based approvers have no employee.
          rec?.employeeId ? (
            <ReferenceField
              source="employeeId"
              reference={employeeRequests.getEmployeesSelect()}
              link={false}
            >
              <FunctionField render={fullName} />
            </ReferenceField>
          ) : (
            (rec?.role ?? rec?.permission ?? "-")
          )
        }
      />
      <FunctionField
        label="Статус"
        sortable={false}
        render={rec => staffRequestStatusLabel(rec?.status)}
      />
      {/* Differs from the approver when a substitute acted on their behalf. */}
      <ReferenceField
        source="statusChangedByUserId"
        reference={accountRequests.getUsersSelect()}
        label="Обработено от"
        link={false}
        sortable={false}
        emptyText="-"
      >
        <FunctionField render={fullName} />
      </ReferenceField>
      <DateField
        source="statusChangedOn"
        label="Дата"
        showTime
        locales="bg-BG"
        sortable={false}
        emptyText="-"
      />
    </Datagrid>
  </ArrayField>
);

export default ApproversTable;
